import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./desktopAuthCompleted.css";

function DesktopAuthCompletedRouteComponent() {
  const { search } = useLocation();
  const [ready, setReady] = useState(false);
  const [countdown, setCountdown] = useState(10);
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    const p = new URLSearchParams(search);
    const code = p.get("code");
    const state = p.get("state");
    const error = p.get("error");
    const desc = p.get("error_description") || "";

    if (!code && !state && !error) {
      window.location.replace("https://app.4sightlabs.com");
      return;
    }

    setReady(true);

    if (code && state) {
      window.location.href = `overwatch://auth?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}`;
    } else if (error) {
      window.location.href = `overwatch://auth?error=${encodeURIComponent(error)}&error_description=${encodeURIComponent(desc)}`;
    }
  }, [search]);

  // Countdown → auto-close
  useEffect(() => {
    if (!ready) return;
    const interval = setInterval(() => {
      setCountdown((n) => {
        if (n <= 1) {
          clearInterval(interval);
          window.close();
          setClosed(true); // fallback if window.close() is blocked
          return 0;
        }
        return n - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [ready]);

  if (!ready) return null;

  return (
    <div className="dac-screen">
      <img
        src="/svgs/Navbar/4SightLabs Logo.svg"
        alt="OverWatch"
        className="dac-top-logo"
      />
      <div className="dac-center">
        <div className="dac-icon-wrap">
          <img
            src="/svgs/4SightLabs_Mini_Logo.svg"
            alt=""
            className="dac-icon"
          />
        </div>
        <h1 className="dac-headline">Launching OverWatch</h1>
        <p className="dac-instruction">
          Click <strong>"Open OverWatch"</strong> to launch the desktop app.
        </p>
        {countdown > 0 ? (
          <p className="dac-countdown">
            This tab will close automatically in <strong>{countdown}</strong>{" "}
            second{countdown !== 1 ? "s" : ""}.
          </p>
        ) : (
          <p className="dac-fallback-close">
            Did not close? You may now close this browser tab.
          </p>
        )}
        <p className="dac-fallback">
          Not working?{" "}
          <a href="https://app.4sightlabs.com" className="dac-link">
            Use OverWatch in your browser.
          </a>
        </p>
      </div>
    </div>
  );
}

export default DesktopAuthCompletedRouteComponent;
